import { useState } from "react";
import { Link } from "react-router";
import styled from "styled-components";

import Card from "./Card2";
import useRevitParameterTemplates from "./useRevitParameterTemplates";
import { useParameters } from "../../../../modules/shared-entities";
import { Bone, FluidAccent } from "../../../../modules/ui-kit";
import Button from "../../components/Button";

const Card2 = styled(Card)`
    --color-fluid: #77a7ff;

    ${ FluidAccent }
`;

const StyledList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
    list-style: none;
    margin: 0;
    padding: 0;
`;

const StyledEmptyState = styled.div`
    cursor: default;
    font-family: var(--font-mono), monospace;
    font-size: 2rem;
    padding: 48px 12px;
`;

const StyledButton = styled(Button)`
    margin: 12px;
`;

export default function List(props) {
    const revitParameterTemplates = useRevitParameterTemplates();

    const parameters = useParameters();

    const [all, setAll] = useState(false);

    if (revitParameterTemplates.loading) return <Skeleton />;
    if (parameters.loading) return <Skeleton />;

    if (!revitParameterTemplates.data) return undefined;

    const items = revitParameterTemplates
        .data
        .revitParameterTemplates
        .filter(
            (revitParameterTemplate) => [
                props.parameterID ? (props.parameterID === revitParameterTemplate.parameterID) : true,
                props.bimClassID ? (props.bimClassID === revitParameterTemplate.bimClassID) : true,
            ].every(Boolean)
        )
        .sort(
            (a, b) => parseInt(b.id, 16) - parseInt(a.id, 16)
        );

    if (!items.length) {
        return (
            <StyledEmptyState>
                <span>no template matches your selection</span>
            </StyledEmptyState>
        );
    }

    return (
        <div>
            <StyledList>
                {
                    items.slice(0, all ? Number.MAX_SAFE_INTEGER : 50).map(
                        (revitParameterTemplate) => (
                            <li key={ revitParameterTemplate.id }>
                                <Link
                                    style={ { textDecoration: "none" } }
                                    to={ revitParameterTemplate.id }
                                >
                                    <Card2
                                        onClick={ () => {} }
                                        { ...revitParameterTemplate }
                                    />
                                </Link>
                            </li>
                        )
                    )
                }
            </StyledList>
            {
                !all && items.length > 50 && (
                    <StyledButton onClick={ () => setAll(true) } disabled>
                        load all
                    </StyledButton>
                )
            }
        </div>
    );
}

function Skeleton() {
    return (
        <StyledList>
            <li style={ { display: "flex", flexDirection: "column", gap: "4px" } }>
                <Bone height="2rem" width="30%" />
                <Bone height="1rem" width="20%" />
            </li>
            <li style={ { display: "flex", flexDirection: "column", gap: "4px" } }>
                <Bone height="2rem" width="22%" />
                <Bone height="1rem" width="26%" />
            </li>
            <li style={ { display: "flex", flexDirection: "column", gap: "4px" } }>
                <Bone height="2rem" width="18%" />
                <Bone height="1rem" width="16%" />
            </li>
            <li style={ { display: "flex", flexDirection: "column", gap: "4px" } }>
                <Bone height="2rem" width="28%" />
                <Bone height="1rem" width="21%" />
            </li>
        </StyledList>
    );
}
